<template>
  <div class="row">
    <div class="col col-12">
      <ul class="category-tree pl-1">
        <li class="category text-left">
          <div class="row">
            <div class="col-1 px-1">
              <div class="h5" v-if="hasChildren" @click="expended = !expended">
                {{ getTreeSymbol }}
              </div>
            </div>
            <div class="col-1 px-1 pt-2">
              <input
                @click="selectTreeCategory()"
                type="checkbox"
                v-model="category.selected"
              />
            </div>
            <div class="col-9 px-2 pt-1 mb-1">
              <div style="font-size:14px" @click="selectTreeCategory()">{{ category.name }}</div>
              <div v-if="expended">
                <v-n-f-r-product-forms-category-tree
                  v-for="child in category.children"
                  :key="child.name"
                  :category="child"
                  :parent.sync="category"
                >
                </v-n-f-r-product-forms-category-tree>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VNFRProductFormsCategoryTree',
  props: {
    category: {
      type: Object,
      required: false
    },
    parent: {
      type: Object,
      required: false
    }
  },
  created(){
    if ( this.category.selected ){
      this.expended = true
    }
  },
  computed: {
    getTreeSymbol() {
      return this.expended ? '-' : '+'
    },
    hasChildren() {
      return this.category.children && this.category.children.length > 0
    }
  },
  data() {
    return {
      expended: false
    }
  },
  watch: {
    'category.selected'( newValue ) {
      if ( newValue === true ) {
        this.selectParents()
      }
    }
  },
  methods: {
    selectTreeCategory() {
      this.category.selected = !this.category.selected
      if ( this.category.selected === false ){
        this.unselectChildren( this.category )
      } else {
        this.selectParents( this.category )
      }
    },
    unselectChildren( cat ) {
      if ( cat.children !== undefined && cat.children.length > 0 ) {
        cat.children.forEach( element => {
          if ( element.selected === true ) {
            element.selected = false
          }
          if ( element.children !== undefined && element.children.length > 0 ) {
            this.unselectChildren( element )
          }
        } )
      }
    },
    selectParents() {
      if ( this.parent !== undefined && this.parent.selected === false ) {
        this.parent.selected = true
      }
    }
  }
}
</script>

<style scoped>
.category-tree {
  list-style-type: none;
  margin: 0;
}
</style>
